/** @jsxImportSource @emotion/react */

import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import PageTemplate from '@page/iyagigo/page-template';
import SpeakingStudy from '@component/iyagigo/speaking/speaking-study';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { TIyagigoSubMenu } from '@datatype/iyagigo/type';
import { actions as modalActions } from '@store/slice/modal-slice';
import { actions as classroomActions } from '@store/slice/classroom-slice';
import { IYAGIGO_PATH } from '@constant/iyagigo/route-path';

const SpeakingStudyPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const isReadOnly = searchParams.get('mode') === 'record';
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const { sessionKey = '' } = useParams<{ sessionKey: string }>();
  const speakingSubMenu = useTypedSelector(
    (state) => state.rootReducer?.navigationReducer?.iyagigo?.subMenu,
  ) as TIyagigoSubMenu['speaking'];

  useEffect(() => {
    dispatch(classroomActions.storeIsStudying(!isReadOnly));
    return () => {
      dispatch(classroomActions.storeIsStudying(false));
    };
  }, [dispatch, isReadOnly]);

  useEffect(() => {
    if (!sessionKey) navigate(IYAGIGO_PATH.SPEAKING_HOME_PATH, { replace: true });
  }, [sessionKey, navigate]);

  const handleBackClick = () => {
    dispatch(
      modalActions.showDialogModal({
        type: 'workbook-quit',
        // 홈에서 선택한 탭을 유지해 기록에서 열었던 대화는 기록 목록으로 돌아간다.
        data: { mainMenu: 'speaking', subMenu: speakingSubMenu ?? (isReadOnly ? 'record' : 'talk') },
      }),
    );
  };

  const handleCompleteClick = () => navigate(IYAGIGO_PATH.SPEAKING_HOME_PATH);

  if (!sessionKey) return null;

  return (
    <PageTemplate title={isReadOnly ? '말하기 기록' : 'AI 말하기'} mode='close' handleNavigationClick={handleBackClick}>
      <SpeakingStudy key={sessionKey} sessionKey={sessionKey} isReadOnly={isReadOnly}
                     handleCompleteClick={handleCompleteClick}/>
    </PageTemplate>
  );
};

export default SpeakingStudyPage;
